import { histogramPlot, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { COLOR_RULE, MA_TYPE } from "../indicatorTypes";
import { fillMacdLine } from "../math/macd";
import { fillMovingAverage } from "../math/movingAverages";
import { valuesReader } from "../math/priceSources";

/**
 * MACD (research §1.4), as TV MACD: the MACD line (fast EMA − slow EMA of
 * the close), its EMA over Signal and the histogram MACD − Signal; as in PO
 * a column is up when higher than the previous one.
 */
export default {
  id: "macd",
  name: "MACD",
  isOscillator: true,
  inputs: [
    periodInput("fast", "Fast", 12),
    periodInput("slow", "Slow", 26),
    periodInput("signal", "Signal", 9),
  ],
  plots: [
    histogramPlot("histogram", "Histogram", COLOR_RULE.TREND),
    linePlot("macd", "MACD", PALETTE.LIME),
    linePlot("signal", "Signal", PALETTE.RED),
  ],
  buffers: ["fastEma", "slowEma"],
  levels: [],

  calculate: (bars, { fast, slow, signal }, series, fromIndex) => {
    fillMacdLine({
      bars,
      fastPeriod: fast,
      slowPeriod: slow,
      averages: series,
      target: series.macd,
      fromIndex,
    });
    fillMovingAverage({
      type: MA_TYPE.EMA,
      read: valuesReader(series.macd),
      target: series.signal,
      period: signal,
      fromIndex,
      toIndex: bars.length,
    });

    for (let index = fromIndex; index < bars.length; index += 1) {
      series.histogram[index] = series.macd[index] - series.signal[index];
    }
  },
};
